import { useEffect } from "react";

function useFacebookPixel({ location }) {
	// Run on every page.
	useEffect(() => {
		if (!window.fbq) {
			return;
		}

		window.fbq("track", "PageView");
	}, [location.pathname]);
}

export default useFacebookPixel;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useFacebookPixel.js